<template>
    <div class="pagination" :style="{background}">
        <div class="pagination_left">
            <button
                :class="{'disabled': value <= 1}"
                class="pagination_btn previous"
                @click="onPagination('previous')"
                type="button"
            >
                <svg-sprite width="20" height="20" icon-id="previous"></svg-sprite>
            </button>
            <button
                :class="{'disabled': value >= pageCount}"
                class="pagination_btn next"
                @click="onPagination('next')"
                type="button"
            >
                <svg-sprite width="20" height="20" icon-id="next"></svg-sprite>
            </button>
		        <field
				        input-class="inputWithEnter"
				        width="48px"
				        padding="8px 10px"
				        margin="0 10px 0 10px"
				        :setInputValue="value"
				        @updateInputWithEnter="onInputWithEnter"
				        isNumber
				        isEnter
				        type="number"
				        is-style2
		        ></field>
            <span>of {{ pageCount }}</span>
        </div>
        <div class="pagination_right">
            Rows per page:
            <field
                margin="0 0 0 10px"
                width="85px"
                @updateSelect="onSelect"
                :autocompleteValue="itemsPerPage"
                :items="pages"
                :isClearable="false"
                is-select
                is-style2
            ></field>
        </div>
    </div>
</template>

<script>

export default {
	name: "Pagination",
	props: {
		isFlagOne: Boolean,
		isBack: Boolean,
		length: Number,
		pageCount: Number,
		itemsPerPage: [ Number, String ],
		page: Number,
		isRefresh: String,
		isRefreshPage: String,
		pages: Array,
		background: {
			type: String,
			default: 'transparent'
		},
	},
	watch: {
		isRefresh(val, oldVal) {
			if (val !== oldVal) {
				this.value = 1;
			}
		},
		isRefreshPage(val, oldVal) {
			if (val !== oldVal) {
				this.value = 1;
			}
		},
		page(val, oldVal) {
			if (val !== oldVal) {
				this.value = val;
			}
		},
	},
	data: () => ({
		value: 1,
	}),
	methods: {
		onInputWithEnter({ value, target }) {
			if (!value || value <= 1) {
				this.value = 1;
			} else if (value > this.pageCount) {
				this.value = this.pageCount;
			} else {
				this.value = value;
			}

			target.value = this.value;
			target.blur();
			this.$emit('updatePagination', this.value);
		},
		onPagination(key) {
			if (key === 'next') {
				if (this.value < this.pageCount) this.value++;
			} else if (this.value > 1) this.value--;

			this.$emit('updatePagination', this.value);
		},
		onSelect({ value }) {
			this.value = 1;
			if (this.isFlagOne) {
				this.$emit('updateCountPagination', value);
			} else {
				this.$emit('updatePreloader');
				if (!this.isBack) this.$emit('updatePagination', 1);
				setTimeout(() => this.$emit('updateCountPagination', value), 1);
			}
		}
	},
	mounted() {
		this.value = 1;
		if (this.page) this.value = this.page;

	}
};
</script>

<style scoped lang="scss">
@import "pagination";
</style>
<style lang="scss">
.pagination_right {
	.field.style2 {
		overflow: hidden;
	}
}
</style>
